export const webPromptOperationSignatures = [
  {
    operationName: 'phoenixAccountGetCustomerPhoneAndConsentDetails',
    signature: '023b3910f83a641d9fdfd3768604184743d2e0cc7996891f9a2504511bbae262',
  },
];
